export const AUTHORIZED_MODULE = 'AUTHORIZED';
export const SYSTEM_MODULE = 'SYSTEM';
export const GUEST_MODULE = 'GUEST';
export const USER_MODULE = 'USER';
export const NOTIFICATION = 'NOTIFICATION';
export const WEB_SOCKET_MODULE = 'WEB_SOCKET_MODULE';
export const REPORT_MODULE = 'REPORT_MODULE';
export const SETTINGS_MODULE = 'SETTINGS_MODULE';
export const VIOLATIONS_MODULE = 'VIOLATIONS_MODULE';
export const ZONES_MODULE = 'ZONES_MODULE';
export const EVACUATIONS_MODULE = 'EVACUATIONS_MODULE';
export const GEOGRAPHY_MODULE = 'GEOGRAPHY_MODULE';
export const POLICIES_MODULE = 'POLICIES_MODULE';
export const RULES_MODULE = 'RULES_MODULE';
export const AGENCY_MODULE = 'AGENCY_MODULE';
export const STOPS_MODULE = 'STOPS_MODULE';
export const PROVIDER_MODULE = 'PROVIDER_MODULE';
export const TELEMETRY_MODULE = 'TELEMETRY_MODULE';
